import styled from 'styled-components';
import { zIndex } from '@ardoq/design-tokens';

export const MainWrapper = styled.div<{
  $isStackActive: boolean;
  $hasModalPage: boolean;
}>`
  z-index: ${zIndex.STACK_PAGE_MANAGER};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: ${({ $isStackActive }) => ($isStackActive ? 'block' : 'none')};
  pointer-events: ${({ $hasModalPage }) => ($hasModalPage ? 'auto' : 'none')};
`;

export const StackItemWrapper = styled.div.attrs({ tabIndex: -1 })<{
  $isModal: boolean;
}>`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 1;
  pointer-events: ${({ $isModal }) => ($isModal ? 'auto' : 'none')};
`;
